module.exports = __webpack_public_path__ + "img/box.1d88fa5c.png";